import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { PATCH_PILLS_REMINDER } from '@app/constants/pillsReminders/pillsReminders'
import Api from '@app/api/pillsReminders/patchPillsReminder'
import { history } from '@app/store/history'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { PILLS_REMINDERS } from '@app/constants/routes'

const patchPillsReminder = createLogic({
  type: PATCH_PILLS_REMINDER,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(PATCH_PILLS_REMINDER))
    try {
      await Api.patchPillsReminder(action.accessToken, action.id, action.reminderData)
      history.push(PILLS_REMINDERS)
      dispatch(apiRequestDone(PATCH_PILLS_REMINDER))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('patchPillsReminder failed without error')
      }
    }
    done()
  },
})

export default patchPillsReminder
